import React from 'react';
import Icon from '../../../../generic-components/Icon';

interface IProps {
title: string;
iconSrc: string;
className?: string;
}

const BusinessDetailsRow = ({ title, iconSrc, className }: IProps) => {
  const handleSetTitleValue = () => {
    if (title.includes('//')) {
      const startIndex = title.indexOf('/') + 2;
      const refactoredOnce = title.substring(startIndex);
      const endIndex = refactoredOnce.indexOf('/');
      return refactoredOnce.substring(0, endIndex);
    }
    return title;
  };
  return (
    <div className='flex gap-4 font-metric text-bw07 pt-2'>
      <Icon iconId='businessLink' src={iconSrc} className='w-[1.5rem] h-[1.5rem]' />
      {title.includes('//') ? <a target='_blank' className={className || 'hover:cursor-pointer'} href={title} rel='noreferrer' id='transaction_details_business_link'>{handleSetTitleValue()}</a> : title}
    </div>
  );
};

export default BusinessDetailsRow;
